<div class="login">

  <mat-card>
    <mat-card-header>
      <mat-card-title style="margin-bottom: 2rem">Reset Your Password</mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <form [formGroup]="form" #loginForm class="form" >
        
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" (keyup.enter)="login()"/>
            @if (form.get('password')?.hasError('required')) {
              <mat-error>Password is a required field</mat-error>
            }
          </mat-form-field>
        </div>
    
        <div style="padding: 1rem 0">
          <a href="/login">Login</a>
        </div>
      </form>

    </mat-card-content>

    <mat-card-actions style="display: flex; justify-content: center; padding-bottom: 1rem">
        <lib-button [disabled]="form.invalid || loading" (click)="login()" >Sign In</lib-button>
    </mat-card-actions>

    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>

</div>